const PAYMENT_MEDIUM_STORAGE_KEY = "client_paymentMedium";
export class PaymentStorageManager {
    store(paymentMedium) {
        const paymentMediumDataString = JSON.stringify(paymentMedium);
        localStorage.setItem(PAYMENT_MEDIUM_STORAGE_KEY, paymentMediumDataString);
    }
    restore() {
        const paymentMediumString = localStorage.getItem(PAYMENT_MEDIUM_STORAGE_KEY);
        if (paymentMediumString !== null) {
            const medium = JSON.parse(paymentMediumString);
            if (medium.type === "channel") {
                medium.method = "Online";
            }
            return medium;
        }
        return null;
    }
    erase() {
        localStorage.removeItem(PAYMENT_MEDIUM_STORAGE_KEY);
    }
}
